import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, isDirty, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import {
  DropDown,
  ExpansionPanelWrapper,
  FormActionButtons,
  PaymentsInputFields
} from 'components';

import validate from './validate';
import { deletePaymentInfo } from 'actions/userSettings';

import {
  PAY_ON_ARRIVAL,
  PAY_PAL_SYSTEM,
  STRIPE_SYSTEM,
  AVAILABLE_PAYMENT_SYSTEMS
} from 'constants/userSettings';
import { useStyles } from './styles';

const initialValues = {
  payments: []
};

const Payments = ({
  handleSubmit,
  deletePaymentInfo,
  paymentsForm,
  isDirty,
  isUpdate
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const payments = paymentsForm.values.payments;  
  const getAvailablePaymentsSystem = index => {
    const createdPayments = paymentsForm.values.payments.map(
      item => item.paymentSystem
    );
    const currentPayment = paymentsForm.values.payments[index].paymentSystem;
    if (currentPayment)
      return [
        currentPayment,
        ...AVAILABLE_PAYMENT_SYSTEMS.filter(x => !createdPayments.includes(x))
      ];
    return AVAILABLE_PAYMENT_SYSTEMS.filter(x => !createdPayments.includes(x));
  };
  const onAddHandler = (fields, id) => {
    fields.push({
      id: id,
      paymentSystem: ''
    });
  };

  const onDeleteHandler = item => {
    if (item.isCreated) deletePaymentInfo(item.id, item.paymentSystem);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Payments')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="payments"
          component={ExpansionPanelWrapper}
          deleteDescription="Note that you will not be able to generate code for the widget if no payment system is connected."
          tabName="payment"
          tabNameAll="all payments"
          isAddDeleteActions={true}
          isUpdate={isUpdate}
          isHiddenAddNewButton={
            payments.length >= AVAILABLE_PAYMENT_SYSTEMS.length
          }
          add={onAddHandler}
          remove={onDeleteHandler}
          getTitle={item => item.paymentSystem}
          getSubTitleLink={item =>
            !item.paymentSystem || item.paymentSystem === PAY_ON_ARRIVAL
              ? null
              : {
                  title: 'Go to the instruction',
                  link:
                    item.paymentSystem === STRIPE_SYSTEM
                      ? '/stripe-instruction'
                      : '/paypal-instruction'
                }
          }
          children={(field, index, meta, fieldObj) => (
            <div className={classes.row}>
              <Field
                name={`${field}.paymentSystem`}
                className={classes.input}
                list={getAvailablePaymentsSystem(index)}
                label="Payment system *"
                placeholder="Choose payment system"
                component={DropDown}
              />
              {fieldObj.paymentSystem === PAY_PAL_SYSTEM && (
                <PaymentsInputFields field={field} paymentSystem="PayPal" />
              )}
              {fieldObj.paymentSystem === STRIPE_SYSTEM && (
                <PaymentsInputFields field={field} paymentSystem="Stripe" 
                 isUpdate={fieldObj.paymentSystem  && fieldObj.isCreated }
                />
              )}
            </div>
          )}
        />
        <FormActionButtons
          isDisabledAction={!isDirty}
          cancelPath="/settings"
          actionLabel="Save"
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deletePaymentInfo: (id, item) => dispatch(deletePaymentInfo(id, item))
});

const mapStateToProps = state => ({
  paymentsForm: state.form.paymentsForm,
  isDirty: isDirty('paymentsForm')(state)
});

export default reduxForm({
  form: 'paymentsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(Payments));
